module.exports = __webpack_public_path__ + "rank0.e2498021.png";